import React from "react";
import "./Our_Story.css";
import { Container } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserTie,
  faGraduationCap,
  faLightbulb,
  faBuilding,
  faUsers,
  faHandshake,
  faPlaneDeparture,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import CommonHeading from "../../Common_Components/Common_Heading/Common_Heading";

function Our_Story() {
  const director = {
    image: "/assets/images/avatars/director_img.jpg",
    name: "Mr. Sanjay Vishwakarma",
    qualification: "Founder & Director",
    role: "KAUMODAKI",
    about: [
      {
        icon: faGlobe,
        text:
          "KAUMODAKI INTERNATIONAL PVT. LTD.. connects skilled professionals with trusted employers across international markets, creating opportunities for candidates to build successful global careers.",
      },
      {
        icon: faUserTie,
        text:
          "With a strong focus on professional recruitment, we identify, evaluate, and place qualified candidates across diverse industries and job roles.",
      },
      {
        icon: faHandshake,
        text:
          "We build strong partnerships with international employers by providing reliable manpower solutions, transparent recruitment processes, and dedicated support.",
      },
      {
        icon: faPlaneDeparture,
        text:
          "Our vision is to make international employment opportunities more accessible while ensuring a smooth, transparent, and professional recruitment journey for every candidate.",
      },
    ],
  };

  return (
    <section className="Our_team section_margin">
   <div className="container">
        <div className="director-card">
          <div className="director-left">
            <div className="director-image">
              <img src={director.image} alt={director.name} />
            </div>

            <h3>{director.name}</h3>

            <p className="qualification">{director.qualification}</p>

            <div className="line"></div>

            <h5>{director.role}</h5>
          </div>

          <div className="director-right">
            <div className="left_heading">
              <CommonHeading title="Our Story" />
            </div>

            <span className="subtitle">
              Your Trusted Partner in Global Manpower Recruitment
            </span>

            {director.about.map((item, index) => (
              <div className="about-item" key={index}>
                <div className="icon">
                  <FontAwesomeIcon icon={item.icon} />
                </div>

                <div className="text">{item.text}</div>
              </div>
            ))}
          </div>
        </div>
    </div>
    </section>
  );
}

export default Our_Story;
